import { cva } from '@vizit/theme';

const tableClasses = cva({
  base: [
    'w-full bg-white',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2',
  ],
});

const tableContainerClasses = cva({
  base: ['border border-primary overflow-auto'],
});

const productCountClasses = cva({
  base: 'h-10 w-36 my-5',
});

const productTableWrapperClasses = cva({
  base: 'flex flex-col gap-6 w-full',
});

export { productCountClasses, productTableWrapperClasses, tableClasses, tableContainerClasses };
